<template>
  <Modal @close="$emit('close')" :title="title">
    <div slot="body">
      <WGModalFirstPage
        @nextPage="nextPage"
        @reloadSessions="$emit('reloadSessions')"
        v-if="currentPage == 1"
      />
      <WGModalSecondPage
        @prevPage="currentPage = 1"
        v-if="currentPage == 2"
        :sessionData="sessionData"
        @closeModal="onCloseModal"
        :editionData="editionData"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import WGModalFirstPage from "@/components/workSession/WGModalFirstPage";
import WGModalSecondPage from "@/components/workSession/WGModalSecondPage";

export default {
  name: "WorkGroupModal",
  data() {
    return {
      currentPage: null,
      sessionData: {},
    };
  },
  components: {
    Modal,
    WGModalFirstPage,
    WGModalSecondPage,
  },
  props: {
    editionData: {
      default: null,
    },
  },
  computed: {
    title() {
      if (this.currentPage == 1)
        return "Defina los parámetros de la sesión de trabajo";
      return "";
    },
  },
  methods: {
    nextPage(sessionData) {
      this.sessionData = sessionData;
      this.currentPage = 2;
    },
    onCloseModal({ showSuccessMessage }) {
      this.$emit("close");

      if (showSuccessMessage) {
        this.$notify({
          title: ["Creación exitosa"],
          type: "success",
        });
      }
    },
  },
  mounted() {
    if (this.editionData) {
      this.currentPage = 2;
    } else {
      this.currentPage = 1;
    }
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
